import { render, staticRenderFns } from "./PlayerImg.vue?vue&type=template&id=3b4e74b5&scoped=true"
import script from "./PlayerImg.vue?vue&type=script&lang=js"
export * from "./PlayerImg.vue?vue&type=script&lang=js"
import style0 from "./PlayerImg.vue?vue&type=style&index=0&id=3b4e74b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4e74b5",
  null
  
)

export default component.exports